<div [class]="skinName">
    <div class="home-bg-img" [ngStyle]="{'background-color':'var(--bg-page)'}">
        <app-navigation [guest]="false"></app-navigation>
        <div id="pagetitle">
            <h1 class="wdn-text-hidden">{{pageH1Tag}}</h1>
        </div>
        <div id="page-content" [ngClass]="(description.length < 350) ? 'autoHeight' : 'normalHeight'">
            <div class="static-bg">
                <h1 class="login-tit">{{heading}}</h1>
                <p id="footer-description" [ngClass]="(description.length < 350) ? 'autoHeight' : 'foogterNormalHeight'" [innerHTML]="description"></p>
            </div>
        </div>
        <div class="clearfix-footer"></div>
    </div>

</div>